import { get } from 'lodash';
import {
  Observable,
  filter,
  first,
  interval,
  map,
  startWith,
  switchMap,
} from 'rxjs';

import { OneTrust } from './one-trust.interface';
import {
  LoadingStatus,
  OneTrustLoaderService,
} from './onetrust-loader.service';

export class OneTrustInstance {
  constructor(private loader: OneTrustLoaderService, private window: Window) {}

  initializeCookiePolicyHtml(): Observable<void> {
    return this.waitForOneTrustMethod('initializeCookiePolicyHtml').pipe(
      map((oneTrust) => oneTrust.initializeCookiePolicyHtml()),
      first()
    );
  }

  toggleInfoDisplay(): Observable<void> {
    return this.waitForOneTrustMethod('ToggleInfoDisplay').pipe(
      map((oneTrust) => oneTrust.ToggleInfoDisplay()),
      first()
    );
  }

  private waitForOneTrustMethod(
    methodName: 'initializeCookiePolicyHtml' | 'ToggleInfoDisplay'
  ): Observable<OneTrust> {
    return this.loader.loadAsStream().pipe(
      filter((loadingStatus) => loadingStatus !== LoadingStatus.NotLoaded),
      first(),
      switchMap(() =>
        interval(50).pipe(
          startWith(0),
          map(() => get(this.window, 'OneTrust') as OneTrust | undefined),
          filter(
            (oneTrust): oneTrust is OneTrust =>
              Boolean(oneTrust && typeof oneTrust[methodName] === 'function')
          ),
          first()
        )
      )
    );
  }
}
